export const ua_messagesdata = {
  loading: "Завантаження",
  error: "Помилка",
  error404: "Сторінку не знайдено",
};
